import React from 'react'

export const IconOrderItems = () => (
  <svg
    width="16"
    height="21"
    viewBox="0 0 12 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 0H2V2H4V4H2V7H0V17C0 19.2091 1.79086 21 4 21H8C10.2091 21 12 19.2091 12 17V7H10V4H8V0ZM4 6H8V7H4V6ZM10 9H2V17C2 18.1046 2.89543 19 4 19H8C9.10457 19 10 18.1046 10 17V9Z"
      fill="var(--flora--colors-brand-3)"
    />
  </svg>
)
